import type { FilterType } from "@cerebruminc/cerebellum";
import type { SearchTermsObject } from "./types";

export const capitalizeFirstLetter = (string?: string) => {
	return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
};

export const pullSearchTerms = (searchTags: Array<FilterType>) => {
	const terms: SearchTermsObject = {};
	for (let i = 0; i < searchTags.length; i++) {
		const tagObject = searchTags[i];
		const searchType: keyof SearchTermsObject = tagObject.searchType;
		if (searchType && !tagObject.disabled) {
			terms[searchType] = tagObject.label;
		}
	}
	return terms;
};
